import {
  Button,
  Modal,
  ModalBody,
  Flex,
  ModalContent,
  ModalFooter,
  ModalOverlay,
  Box,
  Text,
  Grid,
  Badge,
} from '@chakra-ui/react';
import ModalHeaderComponent from '../../../../components/ModalHeader';
import { getDateAndTimeInterval } from '../../../../components/Format';
import './FeedbackModal.scss';
import { getBadgePropsByStatus } from '../../../../utils/badgeUtils';
import { useEffect, useState } from 'react';
import useErrorPage from '../../../../hooks/useErrorPage/useErrorPage';
import { requestServerApi, serverApi } from '../../../../api/api';
import { AxiosResponse } from 'axios';
import { HttpStatus } from '@nestjs/common/enums';
import useFile from '../../../../hooks/useFile/useFile';
export default function FeedbackModal({
  onClose,
  onOpenfeedbackEditModal,
  feed_back,
  start_datetime,
  end_datetime,
  admin_comment,
  learner_name,
  participation_status,
  learner_id,
  company_id,
  t_lesson_learner_documents,
  payment_id,
}: any) {
  const [totalLessons, setTotalLessons] = useState(0);
  const [participatedLessons, setParticipatedLessons] = useState(0);

  const { apiErrorHandler } = useErrorPage();
  const { handleDownload } = useFile();

  useEffect(() => {
    // ここでAPIを呼び出してtotalLessonsとparticipatedLessonsを取得する
    const getStudentsLessonParticipationInfo = async (learnerId: string, companyId: number) => {
      try {
        const result = await requestServerApi<Promise<void | AxiosResponse<any>>>(() =>
          serverApi.learnerControllerGetLearnerTotalLessonsVsParticipatedLessons(
            learnerId,
            companyId,
            payment_id
          ).catch((e) =>
            apiErrorHandler(e, {
              componentName: 'feedback',
              functionName: serverApi.learnerControllerGetLearnerTotalLessonsVsParticipatedLessons.name,
            })
          )
        );
        const responseData = result?.data;
        if (responseData && responseData.code === HttpStatus.OK) {
          setTotalLessons(responseData?.data?.totalLessons || 0);
          setParticipatedLessons(responseData?.data?.participatedLessons || 0);
        } else {
          console.error('APIエラー', responseData?.message || '不明なエラー');
        }
      } catch (error) {
        console.error('エラー', error);
      }
    };

    getStudentsLessonParticipationInfo(learner_id, company_id);
  }, [learner_id, company_id, apiErrorHandler, payment_id]);

  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent minW="55rem">
        <ModalHeaderComponent title={'フィードバック'} />
        <ModalBody>
          <Grid templateColumns="auto auto" columnGap="40px">
            {/* 実施日時 */}
            <Flex direction="column">
              <Text fontWeight="bold">実施日時</Text>
              <Text>{getDateAndTimeInterval(start_datetime, end_datetime)}</Text>
            </Flex>
            {/* 回数 */}
            <Flex direction="column">
              <Text fontWeight="bold">回数</Text>
              <Text>{participatedLessons} / {totalLessons}</Text>
            </Flex>
          </Grid>
          <Flex direction={'column'} mt={5}>
            <Text fontWeight={'bold'}>学習者</Text>
            <Text>{learner_name}</Text>
          </Flex>
          <Flex direction="column" mt={5}>
            <Text fontWeight="bold">受講者</Text>

            {/* 受講者名 */}
            <Flex mt={2} align="center" justify="space-between" maxW="300px">
              <Text>{learner_name}</Text>
              {(() => {
                const badge = getBadgePropsByStatus(participation_status);
                return (
                  <Badge colorScheme={badge.colorScheme} fontSize="md" px={2} py={1}>
                    {badge.label}
                  </Badge>
                );
              })()}
            </Flex>
          </Flex>
          <Box mt={5} mb={1} overflowY="auto">
            <Text fontWeight={'bold'}>内容</Text>
          </Box>
          <Text color={feed_back ? 'black' : 'gray.500'} whiteSpace="pre-wrap">
            {feed_back || 'フィードバックが入力されていません'}
          </Text>
          {/* ★ 学習者の管理者へのコメント */}
          <Box mt={5} mb={1}>
            <Text fontWeight="bold">
              学習者の管理者へのコメント（学習者には見えません）
            </Text>
          </Box>
          <Text color={admin_comment ? 'black' : 'gray.500'} whiteSpace="pre-wrap">
            {admin_comment || 'コメントが入力されていません'}
          </Text>
          <Box mt={5}>
            <Text fontWeight="bold">共有資料</Text>
            {t_lesson_learner_documents && t_lesson_learner_documents.length > 0 ? (
              t_lesson_learner_documents
                .filter((doc: any) => !doc.delete_flg)
                .map((doc: any, index: number) => (
                  <Flex
                    key={index}
                    mt={3}
                    p={3}
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="md"
                    align="center"
                    justify="space-between"
                  >
                    {/* File name or URL */}
                    <Flex direction="column" maxW="70%">
                      <Text fontSize="sm" color="gray.500">
                        {doc.is_internal_file ? 'ファイル' : 'URL'}
                      </Text>
                      <Text
                        fontSize="sm"
                        color="black"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                      >
                        {doc.is_internal_file
                          ? doc.file_url.split('/').pop() // show filename from S3 URL
                          : doc.file_url}
                      </Text>
                    </Flex>

                    {/* Download / Open button */}
                    <Button
                      size="sm"
                      colorScheme="teal"
                      variant="outline"
                      onClick={() =>
                        doc.is_internal_file
                          ? handleDownload(doc.file_url) // handle file download
                          : window.open(doc.file_url, '_blank') // open URL in new tab
                      }
                    >
                      {doc.is_internal_file ? 'ダウンロード' : '開く'}
                    </Button>
                  </Flex>
                ))
            ) : (
              <Text mt={2} color="gray.500">
                共有資料はありません
              </Text>
            )}
          </Box>
        </ModalBody>
        <ModalFooter>
          <Flex justifyContent="right">
            <Button colorScheme="teal" mr={3} onClick={() => onOpenfeedbackEditModal()}>
              編集
            </Button>
            <Button colorScheme="gray" onClick={onClose}>
              キャンセル
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
